module.exports = __webpack_public_path__ + "img/lightbulb-02.e14e7bec.svg";